module.exports = __webpack_public_path__ + "img/as_roma.65982ad1.png";